<template>
  <v-container>
    <v-row class="text-center">
      <!-- <v-col cols="12">
        <v-img
          :src="require('../assets/logo.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col> -->

      <v-col class="mb-4">
        <div class="text-h2 font-weight-black my-5">
          <strong :style="{ color: setting.COLOR }">XPT </strong>
          <strong :style="{ color: setting.COLOR }">Data </strong>
          <v-icon color="black" size="150">mdi-magnify </v-icon>
          <strong :style="{ color: setting.BACKGROUNDCOLOR }"> Viewer</strong>
        </div>
        <p class="text-subtitle-2 font-weight-regular">
          The SAS® Transport File Format(
          <strong class="green--text">XPT</strong>)is an open standard developed
          by SAS to support data transfers between systems, <br />especially
          those running different operating systems.The V5 and V8 transport file
          is widely used in the bio-pharmaceutical industries.
        </p>
        <p class="subtitle-1 font-weight-regular">
          SAS 传输文件格式(
          <strong class="green--text">XPT</strong
          >)是由SAS开发的开放标准，用于支持系统之间的数据传输，
          <br />特别是运行不同操作系统的系统之间的数据传输。V5和V8传输文件被广泛应用于生物制药行业。
        </p>
        <p class="text-h5 font-weight-bold">
          What is <strong class="green--text">Dataset-JSON</strong>?
        </p>
        <p class="text-subtitle-2 font-weight-regular">
          A dataset exchange standard for exchange tabular data leveraging JSON
          designed to meet the regulatory submission needs and eliminating
          limitations of legacy formats. <br />Now,<strong>XPT Viewer</strong>
          is fully capable of converting xpt v5 and v8 data directly into
          <strong class="green--text">Dataset-json</strong> format, so you don't
          need to worry about the implementation of the new standard.
        </p>
        <p class="text-body-1 font-weight-regular">
          利用 JSON
          交换表格数据的数据集交换标准，旨在满足监管部门的提交需求，消除传统格式的限制。<br />现在,<strong
            >XPT Viewer</strong
          >
          已经完全能够将 xpt v5 以及 v8 的数据直接转换为符合
          <strong class="green--text">Dataset-json</strong>
          格式的数据，您不需要为新标准的实施有任何顾虑。
        </p>

        <p class="text-body-1 red--text text--lighten-1 font-weight-regular">
          Note: if you do not use the translation function, all data is only
          stored in your browser, will not do any interaction with the server!
        </p>
        <p class="text-body-1 red--text text--lighten-1 font-weight-regular">
          友情提示：如果不使用翻译功能，所有数据都只在存储在您的浏览器中，不会与服务器做任何交互！
        </p>

        <p class="subheading font-weight-regular blue--text">
          You are welcomed to reach out author to give suggestions directly!
        </p>
        <p class="subheading font-weight-regular blue--text">
          欢迎大家直接与作者联系，提出建议!
          <v-chip
            class="ma-2"
            color="blue"
            outlined
            pill
            href="mailto:yejianfeng186@163.com"
          >
            Jianfeng YE
            <v-icon right>mdi-account-outline</v-icon>
          </v-chip>
        </p>
        <p class="subheading font-weight-regular orange--text">
          If you are using XPT files, please use<br />如果您使用的是SAS7BDAT文件，请使用
          <a
            href="http://www.ctrial.cc/sas7bdatviewer/index.html"
            target="_blank"
            >SAS7BDAT Viewer</a
          >
          ！
        </p>
        <p class="subheading font-weight-regular green--text">
          For help and collaboration with other XPT Viewer developers,
          <br />please refer to online
          <a href="http://www.ctrial.cc/" target="_blank"
            >Clinical Trial Designer</a
          >
        </p>
      </v-col>
    </v-row>
    <!-- <v-row v-if="false">
      <v-col>
        <div v-if="tlf">
          <div v-if="tlf.Title">
            <p v-for="title in tlf.Title" :key="title.Order">{{title.Value}}</p>
          </div>
          <div v-if="tlf.Container">
            <div
              style="display:flex;color:red;border-style:solid;border-width:1px;border-color:1px;"
            >
              <div style="display:flex;width:20%;"></div>
              <div style="display:flex;width:80%;align-items: end;">
                <div v-for="group in tlf.Container.Head.Description" :key="group.Order">
                  <div
                    style="display:flex;justify-content: center;"
                    v-for="layer in group.Layel"
                    :key="layer.Order"
                  >
                    <div
                      v-for="block in layer.Block"
                      :key="block.Order"
                      style="width:200px;color:blue;text-align: center;"
                    >{{block.Value}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style="color:red;border-style:solid;border-width:1px;border-color:green;">
              <div style="display:flex;" v-for="record in tlf.Container.Body" :key="record.Order">
                <div style="display:flex;width:20%;">
                  <div
                    v-for="block in record.Class"
                    :key="block.Order"
                    style="width:100%;color:blue;text-align: left;"
                  >{{block.Value}}</div>
                </div>
                <div style="display:flex;width:80%;">
                  <div
                    v-for="block in record.Description"
                    :key="block.Order"
                    style="width:200px;color:blue;text-align: center;"
                  >{{block.Value}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tlf.Foot">
            <p v-for="foot in tlf.Foot" :key="foot.Order">{{foot.Value}}</p>
          </div>
        </div>
      </v-col>
    </v-row>-->
    <v-row v-if="boolTranslate">
      <v-progress-linear
        color="orange"
        height="10"
        indeterminate
        striped
      ></v-progress-linear>
    </v-row>
    <!-- <FileUploader
      :strURL="strCurrentFilePath"
      :objHeader="objUpdateHeader"
      :objUserInfo="objUserInfo"
      :boolClear="boolUploadClear"
    ></FileUploader> -->
    <v-row>
      <v-col>
        <div
          :class="['drag-area', boolDropActive ? 'drag-area-active' : '']"
          @dragenter="boolDropActive = true"
          @dragleave="boolDropActive = false"
        >
          <v-icon :color="setting.BACKGROUNDCOLOR" size="100"
            >mdi-cloud-upload</v-icon
          >
          <div class="upload-title text-h5">Drop file or click to open</div>
          <input
            type="file"
            ref="fileupload"
            multiple
            accept=".xpt"
            @change="getFileList"
          />
        </div>
      </v-col>
    </v-row>
    <v-card class="mb-4" v-if="fileXptList.length > 0" outlined tile>
      <v-list-item
        class="file-item"
        :style="{ backgroundColor: file.backgroundcolor }"
        v-for="(file, index) in fileXptList"
        :key="index"
        dense
      >
        <v-list-item-avatar>
          <v-icon class="mx-2" :color="file.color">mdi-file</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <span class="mx-2" :style="{ color: file.color }"
            >{{ file.name }} ({{ file.size }})</span
          >
        </v-list-item-content>
        <v-list-item-action>
          <v-btn class="mr-2" icon>
            <v-icon color="red" @click="removeFile(index)">mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <!-- <v-row v-for="(file,index) in arrFileList" :key="index" color="light-blue" outlined dark> -->
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2" color="red" dark @click="clearFileList">
          <v-icon>mdi-delete</v-icon>Clear File List
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col md="6" xs="12" class="d-flex flex-row">
        <v-select
          v-model="strParseType"
          :items="arrParseType"
          item-text="text"
          item-value="value"
          label="Parse Type"
          @change="loadData()"
          outlined
        ></v-select>
      </v-col>
      <v-col md="6" xs="12" class="d-flex flex-row">
        <!-- <v-file-input
          v-model="fileXptList"
          placeholder="Upload your XPT file"
          label="xpt file input"
          @change="loadData($event)"
          color="orange darken-2"
          accept=".xpt"
          prepend-icon="mdi-file-upload"
          outlined
          multiple
          show-size
        >
          <template v-slot:selection="{ text }">
            <v-chip text-color="white" label color="orange darken-2">{{ text }}</v-chip>
          </template>
        </v-file-input>-->
        <v-chip class="ma-2" color="green" text-color="white">{{
          arrDataset.length
        }}</v-chip>
        <v-select
          v-model="objXPT"
          :items="arrDataset"
          item-text="text"
          item-value="value"
          label="Dataset List"
          outlined
          @change="exhibitData"
        >
          <!-- <template v-slot:item="{item}">
                {{item["text"]}}
                <template v-if="item['size']">
                  ({{item["size"]}})
                </template>
          </template>-->
        </v-select>
      </v-col>
      <!-- <v-col md="3" xs="12">
        <v-btn color="green" dark block x-large @click="downloadDatasetJson">
          <v-icon class="mx-2">mdi-cloud-download</v-icon> Dataset-JSON
        </v-btn>
      </v-col> -->
    </v-row>

    <template v-if="arrDataset.length">
      <v-card class="px-3 my-6">
        <v-row class="py-1">
          <v-col @click="copyCode">
            <CodeViewer class="viewer" :script="objScript"></CodeViewer>
            <v-alert v-model="boolCopy" dense type="success">
              Copied to the <strong>clipboard</strong> !
            </v-alert>
          </v-col>
        </v-row>
        <v-row class="py-1">
          <v-col cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              SAS Version
              <strong class="green--text">(SAS 版本)</strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ objDatasetDes["VER"] }}</b>
            </div>
          </v-col>
          <v-col cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              Transition Type
              <strong class="green--text">(传输类型)</strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ strTransType }}</b>
            </div>
          </v-col>
          <v-col cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              XPT Version
              <strong class="green--text">(XPT 版本)</strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ strXPTVer }}</b>
            </div>
          </v-col>
          <v-col cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              XPT Encoding
              <strong class="green--text">(XPT 编码)</strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ strEncodingType }}</b>
            </div>
          </v-col>
        </v-row>
        <!-- <v-row class="py-1">
          <v-col class="px-2">
            <div class="mx-4 text-h4 font-weight-bold">
              <span
                class="mx-1 text-h4 font-weight-green font-weight-bold green--text"
              >{{strXPTVer}}</span>
              {{objDatasetDes["NAME"]}}
              <template
                v-if="objDatasetDes['LABEL']"
              >({{objDatasetDes["LABEL"]}})</template>
            </div>
          </v-col>
        </v-row>-->
        <v-row class="mb-3">
          <v-col class="px-2" cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              Dateset
              <strong class="green--text">(数据集)</strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ objDatasetDes["NAME"] }}</b>
            </div>
          </v-col>
          <v-col class="px-2" cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              Label
              <strong class="green--text">
                <b>(数据集标签)</b>
              </strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ objDatasetDes["LABEL"] }}</b>
            </div>
          </v-col>
          <v-col class="px-2" cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              Variable Count
              <strong class="green--text">
                <b>(变量数量)</b>
              </strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ intVars }}</b>
            </div>
          </v-col>
          <v-col class="px-2" cols="3">
            <div
              class="mx-1 text-subtitle-1 font-weight-blue font-weight-bold blue--text"
            >
              Observation Count
              <strong class="green--text">
                <b>(观测数量)</b>
              </strong>
            </div>
            <div class="mx-1 text-subtitle-2">
              <b>{{ intObs }}</b>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col>
            <v-data-table
              class="mt-3 ctrial-orange"
              :headers="arrVariableDesHeaders"
              :items="arrVariable"
              :items-per-page="15"
              dense
            >
              <!-- <template v-slot:header="{ props }">
                <th
                  class="text-title mp-5"
                  :class="`text-${head.align}`"
                  color="blue"
                  v-for="head in props.headers"
                  :key="head.value"
                >
                  <p class="" :style="{color: 'red'}">
                    {{ head.text.toUpperCase() }}
                  </p>
                </th>
                <v-divider></v-divider>
              </template> -->

              <template v-slot:[`item.NNAME`]="{ item }">
                {{ item.NNAME }}
                <template v-if="item.LONGNAME && item.NNAME !== item.LONGNAME">
                  <p class="green--text">{{ item.LONGNAME }}</p>
                </template>
              </template>
              <template v-slot:[`item.NLABEL`]="{ item }">
                {{ item.NLABEL }}
                <template
                  v-if="item.LONGLABEL && item.NLABEL !== item.LONGLABEL"
                >
                  <p class="green--text">{{ item.LONGLABEL }}</p>
                </template>
              </template>
              <template v-slot:[`item.VSB`]="{ item }">
                <template v-if="item.VSB">
                  <v-icon color="blue darken-2" @click="showHeader(item)"
                    >mdi-eye</v-icon
                  >
                </template>
                <template v-else>
                  <v-icon color="blue darken-2" @click="showHeader(item)"
                    >mdi-eye-off</v-icon
                  >
                </template>
              </template>
              @click:append-outer="boolSearch = !boolSearch"
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="px-3 my-6">
        <v-row>
          <v-col>
            <v-data-table
              class="mt-6 ctrial-green"
              :headers="arrBasicStatisticsHeaders"
              :items="arrBasicStatistics"
              :items-per-page="15"
              dense
            ></v-data-table>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <!-- <v-col md="5" xs="12" class="d-flex flex-row">
          <v-select
            v-model="strOrgin"
            :items="arrLanguage"
            item-text="text"
            item-value="value"
            label="Origin"
            solo
          ></v-select>
          <v-btn class="mb-2" icon large color="blue" @click="exchangeLang">
            <v-icon>mdi-swap-horizontal</v-icon>
          </v-btn>
          <v-select
            v-model="strDist"
            :items="arrLanguage"
            item-text="text"
            item-value="value"
            label="Origin"
            solo
          ></v-select>
        </v-col> -->
        <!-- <v-col md="1" xs="12">
          <v-tooltip top color="blue">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                color="blue"
                dark
                block
                large
                @click="getTranslate"
              >
                <v-icon>mdi-translate</v-icon>
              </v-btn>
            </template>
            <span>Translate</span>
          </v-tooltip>
        </v-col> -->

        <v-col cols="6">
          <v-text-field
            v-model="strSearch"
            prepend-inner-icon="mdi-magnify"
            clear-icon="mdi-close-circle"
            clearable
            label="Search"
            outlined
            :append-outer-icon="boolSearch ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append-outer="boolSearch = !boolSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="4" xs="12" class="d-flex flex-row">
          <v-select
            v-model="strDownloadForm"
            :items="arrDownloadForm"
            item-text="text"
            item-value="value"
            label="Download Form"
            outlined
          ></v-select>
        </v-col>
        <!-- <v-col cols="2">
          <v-btn class="" color="success" @click="downloadCsv" block>
            <v-icon class="mx-2">mdi-cloud-download</v-icon> Download
          </v-btn>
        </v-col> -->
        <v-col md="2" xs="12">
          <v-btn color="green" dark block x-large @click="downloadData">
            <v-icon class="mx-2">mdi-cloud-download</v-icon> Download
          </v-btn>
        </v-col>
      </v-row>
      <v-card class="d-flex justify-start my-3" outlined v-if="boolSearch">
        <div v-for="header of arrXptHeaders" :key="header.value" class="pa-2">
          <v-checkbox class="mx-2" v-model="header.filterable">
            <template v-slot:label>
              <div class="text-caption">{{ header.text }}</div>
            </template>
          </v-checkbox>
        </div>
      </v-card>
      <v-card class="px-3 my-6">
        <v-row>
          <v-col>
            <v-data-table
              class="mt-6 ctrial-blue"
              :headers="arrXptShowHeaders"
              :items="arrObs"
              :search="strSearch"
              :items-per-page="10"
              dense
            >
              <template
                v-for="h in arrXptShowHeaders"
                v-slot:[`header.${h.value}`]="{ header }"
              >
                <v-tooltip color="success" :key="h.value" top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ header.text.split("\n")[0] }}</span>
                  </template>
                  <template v-if="header.text.split('\n')[1]">
                    <span>{{ header.text.split("\n")[1] }}</span>
                  </template>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </v-container>
</template>
<style>
.viewer :hover {
  background: #c5e1a5 !important;
  cursor: pointer;
}
.ctrial-orange tr:hover {
  background: #ffb74d !important;
  color: #e65100;
}
.ctrial-orange tr.v-data-table__selected {
  background: #ffb74d !important;
  color: #e65100;
  font-weight: bolder;
}
.ctrial-blue tr:hover {
  background: #bbdefb !important;
  color: #0d47a1;
}
.ctrial-blue tr.v-data-table__selected {
  background: #bbdefb !important;
  color: #0d47a1;
  font-weight: bolder;
}
.ctrial-green tr:hover {
  background: #c5e1a5 !important;
  color: #33691e;
}
.ctrial-green tr.v-data-table__selected {
  background: #c5e1a5 !important;
  color: #33691e;
  font-weight: bolder;
}

.drag-area {
  border: 2px dashed rgb(143, 193, 235);
  height: 150px;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}

.drag-area-active {
  background: #e3f2fd;
}
.drag-area:hover {
  background: #bbdefb !important;
  border: 2px solid #2e94c4;
}

.file-item:hover {
  /* background: #e3f2fd; */
  border: 1px solid #2e94c4;
  border-radius: 5px;
}
.upload-icon {
  color: #2e94c4;
}

.drag-area input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
</style>

<script>
// var xpt2json = require("xpt2json/dist/xpt2json");
// import {xpt2json} from "xpt2json/dist/xpt2json.js";
import { mapState } from "vuex";
import { readXpt, createDatasetJSON } from "xpt2json";
import { utils, writeFile } from "xlsx";
import * as ss from "simple-statistics";
// import FileUploader from "../components/FileUploader";
import CodeViewer from "../components/CodeViewer";
import config from "../../package.json";

export default {
  name: "XptViewer",
  data: () => ({
    fileXptList: [],
    arrObs: [],
    objXPT: {},
    jsonXpt: {},
    arrXptShowHeaders: [],
    arrXptHeaders: [],
    arrBasicStatistics: [],
    strXPTVer: null,
    strSearch: null,
    strMessage: null,
    boolSearch: false,
    boolTranslate: false,
    boolSnackbar: false,
    boolDropActive: false,
    boolCopy: false,
    objDatasetDes: {},
    intVars: 0,
    intObs: 0,
    strOrgin: "en",
    strDist: "zh",
    strTransType: "XPORT",
    strEncodingType: "ANSI",
    strParseType: "ansi",
    strSourceCode: "",
    strDownloadForm: "xlsx",
    objScript: {},
    arrDataset: [],
    arrLanguage: [
      { value: "en", text: "English" },
      { value: "zh", text: "中文" },
    ],
    arrParseType: [
      { value: "ansi", text: "ANSI" },
      { value: "utf8", text: "UTF-8" },
    ],
    arrDownloadForm: [
      { value: "xlsx", text: "Excel" },
      { value: "json", text: "JSON" },
      { value: "csv", text: "CSV" },
    ],
    arrVariable: [],
    arrVariableDesHeaders: [
      {
        class: "orange--text",
        text: "ID",
        align: "left",
        value: "NVAR0",
        width: "5%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Name",
        align: "left",
        value: "NNAME",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Label",
        align: "left",
        value: "NLABEL",
        width: "25%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Length",
        align: "left",
        value: "NLNG",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Type",
        align: "left",
        value: "TYPE",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Format",
        align: "left",
        value: "NF",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Informat",
        align: "left",
        value: "NIF",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Significant",
        align: "left",
        value: "NFD",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange--text",
        text: "Visiable",
        align: "right",
        value: "VSB",
        width: "10%",
        sortable: false,
      },
    ],
    arrBasicStatisticsHeaders: [
      {
        class: "green--text",
        text: "Name",
        align: "left",
        value: "NAME",
        width: "10%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "N",
        align: "left",
        value: "COUNT",
        width: "10%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "Mean(SD)",
        align: "left",
        value: "MEAN",
        width: "30%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "Median(Q1:Q3)",
        align: "left",
        value: "MEDIAN",
        width: "30%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "Min:Max",
        align: "left",
        value: "RANGE",
        width: "20%",
        filterable: false,
      },
    ],
    tlf: {
      Type: "table",
      Title: [
        {
          Order: 1,
          Value:
            "Demographics and patient characteristics at baseline - Randomized population",
        },
      ],
      Container: {
        Head: {
          Class: [],
          Description: [
            {
              Order: 1,
              Layel: [
                {
                  Order: 1,
                  Block: [{ Order: 1, Value: "Placebo" }],
                },
              ],
            },
            {
              Order: 2,
              Layel: [
                {
                  Order: 1,
                  Block: [{ Order: 1, Value: "Q2W/Up150 Q2W" }],
                },
              ],
            },
            {
              Order: 3,
              Layel: [
                {
                  Order: 1,
                  Block: [{ Order: 1, Value: "All" }],
                },
                {
                  Order: 2,
                  Block: [
                    { Order: 1, Value: "All1" },
                    { Order: 2, Value: "All2" },
                  ],
                },
              ],
            },
          ],
        },
        Body: [
          {
            Order: 1,
            Class: [{ Order: 1, Value: "Age" }],
            Description: [],
          },
          {
            Order: 2,
            Class: [{ Order: 1, Value: "Number" }],
            Description: [
              { Order: 1, Value: "102" },
              { Order: 2, Value: "103" },
              { Order: 3, Value: "104" },
            ],
          },
        ],
      },
      Foot: [
        {
          Order: 1,
          Value:
            "The safety and anti-alirocumab antibody population patients are tabulated according to treatment actually received (as treated). ",
        },
        {
          Order: 2,
          Value:
            "For the other populations, patients are tabulated according to their randomized treatment. ",
        },
        {
          Order: 3,
          Value: "dis_std_populations_a_t.sas",
        },
      ],
    },
  }),
  components: {
    CodeViewer,
    // FileUploader,
  },
  created() {
    this.strVersion = config.version;
    // console.log(this.strVersion);
    // console.log("11111111111");
  },
  methods: {
    bytesToSize(bytes) {
      // console.log(bytes);
      let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "n/a";
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      if (i === 0) return bytes + " " + sizes[i];
      // console.log(bytes / Math.pow(1024, i));
      // console.log((bytes / Math.pow(1024, i)).toFixed(2));
      return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
    },
    getFileList(e) {
      this.boolDropActive = false;
      let files = e.target.files || e.dataTransfer.files;
      // console.log(files);
      if (!files) return;
      [...files].forEach((file) => {
        let objFile = {};
        objFile["file"] = file;
        objFile["name"] = file["name"];
        // console.log(objFile["name"]);
        objFile["size"] = this.bytesToSize(file["size"]);
        objFile["status"] = undefined;
        objFile["color"] = "#039BE5";
        objFile["backgroundcolor"] = "#FFFFFF";
        this.fileXptList.push(objFile);
      });
      this.loadData();
      this.$refs.fileupload.value = null;
    },
    removeFile(key) {
      this.fileXptList.splice(key, 1);
      this.loadData();
    },
    clearFileList() {
      this.fileXptList = [];
      this.arrDataset = [];
    },
    loadData() {
      this.objDatasetDes = {};
      this.strXPTVer = "";
      this.strTransType = "";
      this.strEncodingType = "";
      this.intVars = 0;
      this.intObs = 0;
      this.arrDataset = [];
      // console.log(this.fileXptList);
      if (this.fileXptList && this.fileXptList.length) {
        // console.log(this.fileXptList);
        let arrDataset = [];
        this.fileXptList.forEach((f) => {
          let file = f["file"] || f;
          // console.log(file);
          let reader = new FileReader();
          // reader.readAsBinaryString(this.fileXptList);
          reader.readAsBinaryString(file);
          reader.onload = (res) => {
            let jsonXpt = readXpt(res.target.result, {
              input: "data",
              encoding: this.strParseType,
            });
            // console.log(jsonXpt);
            let strName = "";
            let strLabel = "";
            // console.log(jsonXpt);
            // console.log(this.strParseType);
            if (Array.isArray(jsonXpt)) {
              this.strTransType = "CPORT";

              jsonXpt.map((item) => {
                let objXPT = {};
                strName = item["MEMBER"]["FIRST"]["DSNAME"];
                strLabel = item["MEMBER"]["SECOND"]["LABEL"];
                if (strLabel != "") {
                  objXPT["text"] = strName + "(" + strLabel + ")";
                } else {
                  objXPT["text"] = strName;
                }
                if (f["name"]) {
                  objXPT["name"] = f["name"];
                }
                objXPT["value"] = item;
                arrDataset.push(objXPT);
              });
            } else if (typeof jsonXpt == "object") {
              this.strTransType = "XPORT";
              let objXPT = {};
              let strName = jsonXpt["MEMBER"]["FIRST"]["DSNAME"];
              let strLabel = jsonXpt["MEMBER"]["SECOND"]["LABEL"];
              if (strLabel != "" && strLabel != null) {
                objXPT["text"] = strName + "(" + strLabel + ")";
              } else {
                objXPT["text"] = strName;
              }
              if (f["name"]) {
                objXPT["name"] = f["name"];
              }
              objXPT["value"] = jsonXpt;
              arrDataset.push(objXPT);
            }
            this.jsonXpt = jsonXpt;
            // console.log(arrDataset);
            this.arrDataset = arrDataset;
            if (arrDataset.length > 0) {
              this.arrDataset = arrDataset;
              this.objXPT = arrDataset[0]["value"];
            }
            this.exhibitData();
          };
        });
      } else {
        this.arrVariable = [];
        this.arrBasicStatistics = [];
        this.arrObs = [];
      }
    },
    exhibitData() {
      let arrVariable = [];
      let jsonXpt = this.objXPT;

      this.strXPTVer = jsonXpt["VERSION"] || null;
      this.strEncodingType = jsonXpt["ENCODING"] || null;
      if (jsonXpt["MEMBER"]) {
        let objDatasetDes = {};
        objDatasetDes["NAME"] = jsonXpt["MEMBER"]["FIRST"]["DSNAME"];
        objDatasetDes["LABEL"] = jsonXpt["MEMBER"]["SECOND"]["LABEL"];
        objDatasetDes["VER"] = jsonXpt["MEMBER"]["FIRST"]["VER"];
        this.objDatasetDes = Object.assign({}, objDatasetDes);
      }
      // console.log(jsonXpt);
      let arrObjs = [];
      let intVars = 0;
      let arrBasicStatistics = [];
      if (jsonXpt["OBS"]) {
        let arrXptHeaders = [];
        arrXptHeaders.push({
          text: "ID",
          value: "ID",
          sortable: true,
          filterable: true,
        });
        jsonXpt["OBS"].map((item) => {
          let objItem = Object.assign({}, item);
          let strName = item["NNAME"];

          let strLabel = item["NLABEL"] || null;
          let obsHeader = {
            class: "blue--text",
            text: "",
            value: "",
            sortable: true,
            filterable: true,
            align: "center",
          };

          strLabel = strName + "\n(" + strLabel + ")";

          // obsHeader["text"] = strName + strLabel;
          obsHeader["text"] = strLabel;
          obsHeader["value"] = strName;
          arrXptHeaders.push(obsHeader);
          let arrNonEmpty = [];

          item["RECORDS"].map((subItem, index) => {
            if (!arrObjs[index]) {
              arrObjs.push({ strName: subItem });
              arrObjs[index]["ID"] = index + 1;
            }
            if (subItem) {
              if (objItem["NFORM"]) {
                if (objItem["NFORM"] == "$") {
                  if (objItem["NFL"] < subItem.length) {
                    arrObjs[index][strName] = subItem.substr(0, objItem["NFL"]);
                  } else {
                    arrObjs[index][strName] = subItem;
                  }
                } else {
                  // if (objItem["NFORM"] == "YYMMDD") {
                  if (objItem["NFL"]) {
                    let datetime = new Date("1960-01-01");
                    datetime.setDate(datetime.getDate() + subItem);
                    arrObjs[index][strName] = datetime.toLocaleDateString();
                  } else {
                    arrObjs[index][strName] = subItem;
                  }
                }
              } else if (objItem["NFL"] && subItem) {
                arrObjs[index][strName] = subItem.toFixed(objItem["NFD"]);
              } else {
                arrObjs[index][strName] = subItem;
              }
            }
            if (subItem) {
              arrNonEmpty.push(subItem);
            }
          });
          // console.log(arrObjs);
          intVars = item["RECORDS"].length;

          if (item["NTYPE"] == 1 && arrNonEmpty.length > 0) {
            objItem["TYPE"] = "Numeric";
            let objBasicStatistics = {};
            objBasicStatistics["COUNT"] = arrNonEmpty.length;
            objBasicStatistics["NAME"] = item["NNAME"];
            objBasicStatistics["MEAN"] =
              ss.mean(arrNonEmpty).toFixed(1) +
              " (" +
              ss.standardDeviation(arrNonEmpty).toFixed(2) +
              ")";
            objBasicStatistics["MEDIAN"] =
              ss.median(arrNonEmpty).toFixed(1) +
              " (" +
              ss.quantile(arrNonEmpty, 0.25).toFixed(2) +
              " : " +
              ss.quantile(arrNonEmpty, 0.75).toFixed(2) +
              ")";
            objBasicStatistics["RANGE"] =
              ss.min(arrNonEmpty).toFixed(2) +
              " : " +
              ss.max(arrNonEmpty).toFixed(2);
            arrBasicStatistics.push(objBasicStatistics);
          } else {
            objItem["TYPE"] = "Character";
          }
          // console.log(objItem);
          if (objItem["NFORM"]) {
            objItem["NF"] = objItem["NFORM"] + objItem["NFL"];
            if (objItem["NFD"]) {
              objItem["NF"] = objItem["NFL"] + "." + objItem["NFD"];
            }
          } else if (objItem["NFL"]) {
            objItem["NF"] = objItem["NFL"];
            if (objItem["NFD"]) {
              objItem["NF"] = objItem["NFL"] + "." + objItem["NFD"];
            }
          }
          if (objItem["NIFORM"]) {
            objItem["NIF"] = objItem["NIFORM"] + objItem["NIFL"];
            if (objItem["NIFD"]) {
              objItem["NIF"] = objItem["NIFL"] + "." + objItem["NIFD"];
            }
          } else if (objItem["NIFL"]) {
            objItem["NIF"] = objItem["NIFL"];
            if (objItem["NIFD"]) {
              objItem["NIF"] = objItem["NIFL"] + "." + objItem["NIFD"];
            }
          }
          objItem["VSB"] = true;
          delete objItem["OBS"];
          arrVariable.push(objItem);
        });
        this.arrBasicStatistics = arrBasicStatistics;
        this.intVars = jsonXpt["OBS"].length;
        this.intObs = intVars;
        this.arrXptHeaders = JSON.parse(JSON.stringify(arrXptHeaders));
        this.arrXptShowHeaders = JSON.parse(JSON.stringify(arrXptHeaders));
        this.arrObs = arrObjs;
        this.arrVariable = arrVariable;
        this.generateCode();
        // console.log(arrVariable);
      }
    },
    generateCode() {
      let strXPTVer = this.strXPTVer || "";
      let strFileName = "FileName";
      strXPTVer = strXPTVer.toLowerCase();
      let strEncodingType = 'encoding = "' + this.strParseType + '"';
      let intIndex = this.arrDataset.findIndex((dataset) => {
        return dataset["value"] == this.objXPT;
      });
      let strContent = "";
      if (intIndex > -1) strFileName = this.arrDataset[intIndex]["name"];

      if (this.strTransType == "XPORT") {
        if (strXPTVer == "v5") {
          strContent = `
          //libname newlib 'sas-library';
          libname tranfile xport "${strFileName}" ${strEncodingType};
          proc copy inlib=tranfile outlib=work;
          run;
          `;
        } else {
          strContent = `
          //libname newlib 'sas-library';
          libname tranfile "${strFileName}";
          %xpt2loc(libref=work,filespec=tranfile);
          `;
        }
      } else {
        strContent = `
          //libname newlib 'sas-library';
          filename tranfile " ${strFileName}" ${strEncodingType};
          proc cimport infile=tranfile  library=work;
          run;
        `;
      }
      // console.log(strContent );
      this.objScript = { code: strContent, lang: "sas" };
    },
    showHeader(item) {
      item["VSB"] = !item["VSB"];
      let arrHeader = ["ID"];
      this.arrVariable.map((subItem) => {
        // console.log(subItem["VSB"]);
        if (subItem["VSB"]) {
          arrHeader.push(subItem["NNAME"]);
        }
      });
      this.arrXptShowHeaders = this.arrXptHeaders.filter((subItem) => {
        return arrHeader.indexOf(subItem["value"]) > -1;
      });
    },
    exchangeLang() {
      let t = this.strOrgin;
      this.strOrgin = this.strDist;
      this.strDist = t;
    },
    getTranslate() {
      if (this.objXPT && this.fileXptList) {
        let strSrc = this.strOrgin;
        let strDst = this.strDist;
        // let jsonXPT =this.objXPT.map(item=>{
        //   console.log(item);
        //   return item;
        // });
        let objNumeric = {};
        let jsonXPT = JSON.parse(JSON.stringify(this.objXPT));
        jsonXPT["OBS"] = jsonXPT["OBS"].map((item) => {
          if (item["NTYPE"] == 1) {
            objNumeric[item["NNAME"]] = item["RECORDS"];

            delete item["RECORDS"];
          }
          return item;
        });
        // console.log(objNumeric);

        this.boolTranslate = true;
        this.$axios
          // .post("/translate", {
          .post("http://www.clinicaltrialdesigner.com/phpapi/translate", {
            data: jsonXPT,
            step: "300",
            sleep: "1.5",
            src: strSrc,
            dst: strDst,
          })
          .then((res) => {
            this.boolTranslate = false;
            // console.log(res);
            if (res.data["OBS"]) {
              res.data["OBS"] = res.data["OBS"].map((item) => {
                if (item["NTYPE"] == 1) {
                  let strName = item["NNAME"];
                  // console.log(strName);
                  // console.log(objNumeric[strName]);
                  // console.log(objNumeric[strName]["RECORDS"]);
                  item["RECORDS"] = objNumeric[strName];
                }
                return item;
              });
            }
            this.objXPT = res.data;
            // console.log(this.objXPT);
            this.strOrgin = strDst;
            this.strDist = strSrc;
            this.exhibitData();
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.strMessage = "Please upload your XPT5 file";
        this.boolSnackbar = true;
      }
    },
    copyCode() {
      this.boolCopy = true;
      this.$copyText(this.objScript["code"]);
      setTimeout(() => {
        this.boolCopy = false;
      }, "5000");
    },
    downloadData() {
      if (this.strDownloadForm == "xlsx") {
        if (this.objXPT) {
          // let strFileName = this.fileXptList["name"];
          // console.log(this.objXPT["MEMBER"]);
          // let strFileName = this.objXPT["MEMBER"]["FIRST"]["DSNAME"];
          // let strNewFileName = strFileName.substring(
          //   0,
          //   strFileName.lastIndexOf(".")
          // );

          // let csvFile = parse(this.arrObs);
          let strNewFileName = this.objXPT["MEMBER"]["FIRST"]["DSNAME"];

          let wsData = utils.json_to_sheet(this.arrObs);
          let arrSheet = [{ name: strNewFileName, value: wsData }];
          let workbook = utils.book_new();
          arrSheet.forEach((item) => {
            utils.book_append_sheet(workbook, item.value, item.name);
          });
          writeFile(workbook, strNewFileName + ".xlsx", {
            bookType: "xlsx",
            bookSST: false,
            type: "array",
          });
          // let eleLink = document.createElement("a");
          // console.log(strFileName);
          // console.log(strNewFileName + ".xlsx");
          // eleLink.download = strNewFileName + ".xlsx";
          // eleLink.style.display = "none";
          // let blob = new Blob(
          //   [
          //     writeFile(workbook, strNewFileName + "2222.xlsx", {
          //       bookType: "xlsx",
          //       bookSST: false,
          //       type: "array",
          //     }),
          //   ],
          //   {
          //     type: "application/octet-stream",
          //   }
          // );
          // eleLink.href = URL.createObjectURL(blob);

          // document.body.appendChild(eleLink);
          // eleLink.click();
          // document.body.removeChild(eleLink);
        }
      } else if (this.strDownloadForm == "json") {
        if (this.jsonXpt) {
          // console.log(this.jsonXpt);
          let obj = createDatasetJSON(this.jsonXpt);
          // console.log(obj);
          let strFileName = this.fileXptList[0]["name"];
          // console.log(this.fileXptList);
          // console.log(strFileName);
          // console.log(obj);
          // let strFileName = this.objXPT["MEMBER"]["FIRST"]["DSNAME"];
          let strNewFileName = strFileName.substring(
            0,
            strFileName.lastIndexOf(".")
          );

          let jsonFile = JSON.stringify(obj);
          let eleLink = document.createElement("a");
          eleLink.download = strNewFileName + ".json";
          eleLink.style.display = "none";
          let blob = new Blob([jsonFile], {
            type: "application/json;;",
          });
          eleLink.href = URL.createObjectURL(blob);

          document.body.appendChild(eleLink);
          eleLink.click();
          document.body.removeChild(eleLink);
        }
      } else {
        // if (this.objXPT) {
        //   // let strFileName = this.fileXptList["name"];
        //   // console.log(this.objXPT["MEMBER"]);
        //   let strFileName = this.objXPT["MEMBER"]["FIRST"]["DSNAME"];
        //   let strNewFileName = strFileName.substring(
        //     0,
        //     strFileName.lastIndexOf(".")
        //   );
        //   let csvFile = parse(this.arrObs);
        //   // console.log(csvFile);
        //   let eleLink = document.createElement("a");
        //   eleLink.download = strNewFileName + ".csv";
        //   eleLink.style.display = "none";
        //   let blob = new Blob(["\ufeff" + csvFile], {
        //     type: "text/csv;charset=utf-8;",
        //   });
        //   eleLink.href = URL.createObjectURL(blob);
        //   document.body.appendChild(eleLink);
        //   eleLink.click();
        //   document.body.removeChild(eleLink);
        // }
      }
    },
    downloadDatasetJson() {
      if (this.jsonXpt) {
        // console.log(this.jsonXpt);
        let obj = createDatasetJSON(this.jsonXpt);
        // console.log(obj);
        let strFileName = this.fileXptList[0]["name"];
        // console.log(this.fileXptList);
        // console.log(strFileName);
        // console.log(obj);
        // let strFileName = this.objXPT["MEMBER"]["FIRST"]["DSNAME"];
        let strNewFileName = strFileName.substring(
          0,
          strFileName.lastIndexOf(".")
        );

        let jsonFile = JSON.stringify(obj);
        let eleLink = document.createElement("a");
        eleLink.download = strNewFileName + ".json";
        eleLink.style.display = "none";
        let blob = new Blob([jsonFile], {
          type: "application/json;;",
        });
        eleLink.href = URL.createObjectURL(blob);

        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
      }
    },
  },
  computed: mapState({
    setting: "setting",
  }),
};
</script>
